import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PublicApiService {

  base_url: string = environment.base_url;

  constructor(private http: HttpClient) { }

  get(url: string): Observable<any> {
    return this.http.get(environment.base_url + url);
  }

  post(url: string, body: any): Observable<any> {
    return this.http.post(environment.base_url + url, body);
  }
  put(url: string, body: any): Observable<any> {
    return this.http.put(environment.base_url + url, body);
  }

  getId(url) {
    var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    var match = url.match(regExp);

    if (match && match[2].length == 11) {
      return match[2];
    } else {
      return 'error';
    }
  }
}
